import axios from 'axios';
export async function getSmartReportingData(config = {}) {
  const [invoices, products] = await Promise.all([
    axios.get('/api/running', config), axios.get('/api/products', { ...config, params: { active: 'all' } })
  ]);
  if (!Array.isArray(invoices.data) || !Array.isArray(products.data)) throw new Error('Unexpected reporting response. Refresh to try again.');
  return { invoices: invoices.data, products: products.data };
}
